module["exports"] = [
  "### عمارة",
  "### طابق",
  "### شقة",
  "### بناية",
  "### بيت"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/address/secondary_address.js
// module id = 2374
// module chunks = 1609